import { api } from './api';
import type { SjabloonMetRollen } from '@types';

// ============================================
// Sjabloon API Functions
// ============================================

/**
 * Haal alle sjablonen op voor de huidige organisatie
 */
export const getSjablonen = async (): Promise<SjabloonMetRollen[]> => {
  const response = await api.get<SjabloonMetRollen[]>('/sjablonen');
  return response.data;
};

/**
 * Haal een volledig sjabloon op door ID (met rollen, assen en stellingen)
 */
export const getSjabloonById = async (id: number): Promise<SjabloonMetRollen> => {
  const response = await api.get<SjabloonMetRollen>(`/sjablonen/${id}`);
  return response.data;
};
